<template>
  <div>
    <div class="deal-content-dateline">
      <template v-if="user && user.profile && user.profile.firstName">
        {{ $t('deal.createdBy') }}
        {{ user.profile.firstName }}
        {{ $t('deal.createdBy_On') }}
        {{
          $dateFns.format(publishDate || createDate, 'dd.MM.yyyy', {
            locale: dateLocale,
          })
        }}
      </template>
      <template v-else>
        {{ $t('deal.createdOn') }}
        {{
          $dateFns.format(publishDate || createDate, 'dd.MM.yyyy', {
            locale: dateLocale,
          })
        }}
      </template>
    </div>
    <h3 class="hg-title">
      {{ $t('deal.description') }}
    </h3>
    <client-only>
      <HgEditorContent :content="migrateContent(forwarderContent || content)" />
    </client-only>
  </div>
</template>

<script>
export default {
  components: {
    HgEditorContent: () => import('@/components/ui/HgEditorContent'),
  },
  props: {
    publishDate: {
      type: String,
      default: '',
    },
    createDate: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: () => {},
    },
    content: {
      type: [Object, String],
      default: () => {},
    },
    forwarderContent: {
      type: [Object, String],
      default: () => {},
    },
  },
  computed: {
    dateLocale() {
      return this.$i18n.locale === 'at'
        ? 'de'
        : this.$i18n.locale === 'ch'
        ? 'de'
        : this.$i18n.locale;
    },
  },
  methods: {
    migrateContent(content) {
      // use tiptap v1 content in v2 editor display
      return JSON.parse(JSON.stringify(content), (key, value) => {
        if (key === 'marks') {
          for (let i = 0; i < value.length; i++) {
            if (value[i].type && value[i].type === 'link') {
              value[i].attrs['data-partner'] = this.getDataPartner(
                value[i].attrs.href,
              );
            }
          }
          return value;
        }
        switch (value) {
          case 'bullet_list':
            return 'bulletList';
          case 'list_item':
            return 'listItem';
          case 'code_block':
            return 'codeBlock';
          case 'hard_break':
            return 'hardBreak';
          case 'horizontal_rule':
            return 'horizontalRule';
          case 'ordered_list':
            return 'orderedList';
          case 'table_cell':
            return 'tableCell';
          case 'table_header':
            return 'tableHeader';
          case 'table_row':
            return 'tableRow';
          case 'todo_list':
            return 'taskList';
          case 'todo_item':
            return 'taskItem';
          case 'button':
            return 'link';
          default:
            return value;
        }
      });
    },
    getDataPartner(dealUrl) {
      // retrieve base host and domain from dealUrl
      if (dealUrl) {
        const match = dealUrl.match(/^(https?:\/\/)?([a-zA-Z0-9-._~]+)/);
        // if found and if not part of the holidayguru domains and
        // https://urlaubsguru-gutschein.de/
        // https://urlaubsguru-gutschein.watado.de/
        // https://urlaubsguru.urlaubsgutschein.kaufen/
        if (
          match &&
          match.length &&
          !match[match.length - 1].match(
            /urlaubsguru\.de|urlaubsguru\.at|holidayguru\.es|holidayguru\.nl|holidayguru\.ch|urlaubsguru-gutschein\.de|urlaubsguru-gutschein\.watado\.de|urlaubsguru\.urlaubsgutschein\.kaufen/,
          )
        ) {
          // return the found host and domain
          return match[match.length - 1];
        }
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.hg-title {
  margin-top: 0.5rem !important;
  margin-bottom: 1rem;
}

.deal-content-dateline {
  color: $gray-600;
  margin-top: 1rem;
}
</style>
<style>
.deal-content-wrapper .deal-content .hg-alert-box.info {
  margin-bottom: 2.5rem;
}
</style>
